// NOTE
// Please use your own firebase details below. For more details visit: https://pixinvent.com/demo/vuesax-vuejs-admin-dashboard-template/documentation/development/firebaseIntegration.html


import firebase from 'firebase/app'
import "firebase/firestore"
import "firebase/storage"

// Initialize Firebase
var config = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  messagingSenderId: "914001522995"
};

firebase.initializeApp(config);

let snapshotToArray = (snapshot) => {
  // var data = {};

  // snapshot.forEach(doc => {
  //   data[doc.id] = doc.data();
  //   data[doc.id]["id"] = doc.id;
  // });

  return Object.values(snapshot.docs);
}

let docToArray = (doc) => {
  var data = {}
  data = doc.data()
  data.id = doc.id

  return data
}

let db = firebase.firestore()
let storage = firebase.storage()

export {
  firebase,
  db,
  snapshotToArray,
  docToArray,
  storage
}
